import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-wrap gap-1 items-center" }
const _hoisted_2 = {
  key: 0,
  class: "px-2 py-0.5 rounded text-[10px] font-bold bg-gold text-white"
}
const _hoisted_3 = {
  key: 1,
  class: "px-2 py-0.5 rounded text-[10px] font-bold bg-[#FFF9EE] text-[#9A6E1E] border border-gold/30"
}


import { HourGeneralInfo } from "@/types/calculators";


export default /*@__PURE__*/_defineComponent({
  __name: 'SpiritsAndEliteHoursComponent',
  props: {
    general: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.general.elite_markers.is_gui_deng_tian_men)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, " ★ 贵登天门 "))
      : _createCommentVNode("", true),
    (__props.general.elite_markers.is_si_da_ji_shi)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, " 四大吉时 (" + _toDisplayString(__props.general.elite_markers.si_da_ji_shi.symbol_8gan_4wei) + ") ", 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.general.shen_sha.auspicious_gods, (auspGod) => {
      return (_openBlock(), _createElementBlock("span", {
        key: auspGod.code,
        class: "px-1.5 py-0.5 rounded text-[10px] bg-secondary text-brown"
      }, _toDisplayString(auspGod.name.split(" ")[0]), 1))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.general.shen_sha.evil_gods, (evilGod) => {
      return (_openBlock(), _createElementBlock("span", {
        key: evilGod.code,
        class: "px-1.5 py-0.5 rounded text-[10px] bg-error/10 text-error"
      }, _toDisplayString(evilGod.name.split(" ")[0]), 1))
    }), 128))
  ]))
}
}

})